<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="name"
            name="name"
            label="Name"
            validate="required"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-3">
          <z-input
            v-model="target"
            name="target"
            label="Target # Views"
            placeholder="# views"
            type="Number"
            min="0"
            validate="required"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-3">
          <button
            v-show="isSave"
            class="btn btn-primary mt-4"
            @click="performSave()"
          >
            Save
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <media-listing v-if="id !== null" />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-7">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-4">
          <div class="custom-buttons">
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTabs from '@/Components/ZElements/Tabs'
import ZInput from '@/Components/ZElements/Input'
import MediaListing from '@/Components/DashboardComponents/forms/media-listing'
export default {
  name: 'component-dialog',
  components: {
    ZDialog,
    ZTabs,
    ZInput,
    MediaListing,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
    }
  },
  mounted() {
    this.reset()
  },
  computed: {
    ...mapGetters('dashboardComponents', ['dashboardComponent']),
    ...mapGetters('organizations', ['examineOrganization']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Edit Component'
      if (this.show) {
        if (this.show.isAdd && this.dashboardComponent.id === null) {
          _title = 'Add Component'
        } else if (this.dashboardComponent) {
          _title = `Edit Component`
        }
      }
      return _title
    },
    id() {
      let _id = null
      if (this.dashboardComponent) {
        _id = this.dashboardComponent.id
      }
      return _id
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
    name: {
      get() {
        let _data = null
        if (this.dashboardComponent) {
          _data = this.dashboardComponent.name
        }
        return _data
      },
      set(value) {
        this.setComponentData({
          name: 'name',
          value: value,
        })
      },
    },
    target: {
      get() {
        let _data = null
        if (this.dashboardComponent) {
          _data = this.dashboardComponent.target
        }
        return _data
      },
      set(value) {
        this.setComponentData({
          name: 'target',
          value: parseInt(value),
        })
      },
    },
  },
  methods: {
    ...mapActions('dashboardComponents', ['setComponentData', 'saveComponent']),
    reset() {
      this.validErrors = []
      this.isSave = false
      this.invalidMessage = ''
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.dashboardComponent.name === '') {
        valid = false
        this.validErrors.push('name')
      }
      if (
        this.dashboardComponent.target === undefined ||
        this.dashboardComponent.target === null
      ) {
        valid = false
        this.validErrors.push('target')
      }
      if (this.show.isAdd) {
      }
      return valid
    },
    async performSave() {
      let success = false
      let valid = this.validate()
      if (valid) {
        this.setComponentData({
          name: 'orgId',
          value: this.examineOrganization.id,
        })
        // save the Dashboard Component
        let data = {
          id: this.dashboardComponent.id,
          org_id: this.examineOrganization.id,
          name: this.dashboardComponent.name,
          target: this.dashboardComponent.target,
        }
        await this.saveComponent(data)
        success = true
        this.isSave = false
        this.reset()
      } else {
        success = false
        this.invalidMessage = 'missing ' + this.validErrors.join(', ')
      }
      return success
    },
    close() {
      this.reset()
      this.$emit('saved')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
</style>
